import { Row } from '@unistocks/components/layout/flex';
import { Text } from '@unistocks/components/text/text';
import { triggerHaptics } from '@unistocks/shared/utils/haptics/haptics';
import React from 'react';
import { Switch, SwitchProps, useTheme, ViewProps } from 'tamagui';

export type SwitchButtonProps = SwitchProps & {
  leftLabel: string;
  rightLabel: string;
  thumbProps?: ViewProps;
};

export const SwitchButton: React.FC<SwitchButtonProps> = ({
  leftLabel,
  rightLabel,
  thumbProps,
  checked,
  native = true,
  nativeProps,
  onCheckedChange,
  ...props
}) => {
  const { unistocks: thumbColor, color5: trackColor } = useTheme();

  const handleChange = () => {
    triggerHaptics(checked ? 'toggleOff' : 'toggleOn');
    onCheckedChange?.(!checked);
  };

  return (
    <Row alignItems="center" {...props} cursor="pointer" onPress={handleChange}>
      <Text size={'$3'} color={checked ? '$gray9' : '$color'}>
        {leftLabel}
      </Text>

      <Switch
        native={native}
        bg={'$color5'}
        size={'$2'}
        checked={checked}
        onPress={e => e.stopPropagation()}
        onCheckedChange={onCheckedChange}
        activeStyle={{
          backgroundColor: '$color5'
        }}
        nativeProps={{
          onTouchStart: () => triggerHaptics(checked ? 'toggleOff' : 'toggleOn'),
          thumbColor: thumbColor.get(),
          trackColor: { false: trackColor.get(), true: trackColor.get() },
          ...nativeProps
        }}
      >
        <Switch.Thumb
          transition={'quicker'}
          bg={'$unistocks'}
          activeStyle={{ bg: '$unistocks' }}
          {...thumbProps}
        />
      </Switch>

      <Text size={'$3'} color={checked ? '$color' : '$gray9'}>
        {rightLabel}
      </Text>
    </Row>
  );
};

SwitchButton.displayName = 'SwitchButton';
